import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface HelpTooltipProps {
    text: string;
    size?: 'small' | 'medium' | 'large';
}

function HelpTooltip(props: HelpTooltipProps) {
    const { text, size = 'small' } = props;
    return (
        <Tooltip title={text} arrow>
            <IconButton size={size} sx={{ p: 0.25, ml: 0.5, verticalAlign: 'middle' }} onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
                <HelpOutlineIcon fontSize={size} color="action" />
            </IconButton>
        </Tooltip>
    );
}

export default HelpTooltip;
